import { AssetItem, RecommendedAsset } from 'config/api/actionLibrary/actionLibrary.types';

/**
 * Filters recommended assets by search term
 */
export const filterRecommendedAssets = (assets: RecommendedAsset[], search: string): RecommendedAsset[] => {
  if (!assets || !Array.isArray(assets)) {
    return [];
  }
  if (!search) return assets;

  const searchLower = search.toLowerCase();
  return assets.filter(
    asset =>
      asset?.name?.toLowerCase().includes(searchLower) ||
      asset?.owner?.profile?.firstName?.toLowerCase().includes(searchLower) ||
      asset?.owner?.profile?.lastName?.toLowerCase().includes(searchLower) ||
      asset?.owner?.email?.toLowerCase().includes(searchLower) ||
      asset?.category?.name?.toLowerCase().includes(searchLower) ||
      asset?.type?.toLowerCase().includes(searchLower),
  );
};

/**
 * Filters available assets by search term and excludes recommended ones
 */
export const filterAvailableAssets = (availableAssets: AssetItem[], recommendedAssets: RecommendedAsset[], search: string): AssetItem[] => {
  if (!availableAssets) return [];

  const recommendedIds = new Set(recommendedAssets.map(a => a.id));
  let filtered = availableAssets.filter(asset => !recommendedIds.has(asset.id));

  if (search) {
    const searchLower = search.toLowerCase();
    filtered = filtered.filter(
      asset =>
        asset.name.toLowerCase().includes(searchLower) ||
        asset.owner.fullName.toLowerCase().includes(searchLower) ||
        asset.owner.email.toLowerCase().includes(searchLower) ||
        (asset.category && asset.category.name.toLowerCase().includes(searchLower)),
    );
  }

  return filtered;
};
